import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from '@tanstack/react-router';

import ResetForm from '@/components/organism/ResetPassword/ResetForm';
import { useAppDispatch } from '@/store';
import { forgotPasswordThunk } from '@/store/thunks/auth/forgotPasswordThunk';
import { selectAuthError } from '@/store/selectors/auth';

export default function ResetPassword() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const error = useSelector(selectAuthError);

  const handleSubmit = useCallback(
    async(values: { emailAddress: string }) => {
      try {
        await dispatch(forgotPasswordThunk({ emailAddress: values.emailAddress })).unwrap();
        void navigate({ to: '/reset-password' });
      } catch {
        // Error handled via Redux state
      }
    },
    [dispatch, navigate]
  );

  return <ResetForm onSubmit={(values) => { void handleSubmit(values); }} error={error} />;
}
